import React from 'react';
import ContentLoader from 'react-content-loader';

import { StarAiFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

import { loaderContainerStyles } from '../styles';

const Loader: React.FC<{ title?: string }> = ({ title }) => {
  return (
    <Stack className={cn('mt-12', loaderContainerStyles)} direction="col">
      {title ? (
        <Stack alignItems="center" className="animate-pulse mb-16" direction="row" gapX={8}>
          <StarAiFill fillColorToken="icon-placeholder" />
          <Typography className="text-text-placeholder" variant="body-short-01">
            {title}
          </Typography>
        </Stack>
      ) : null}
      <ContentLoader className="flex-grow">
        <rect fill="#F2F2F2" height="14" rx="4" width="518" x="0" y="0" />
        <rect fill="#F2F2F2" height="14" rx="4" width="585" x="0" y="32" />
        <rect fill="#F2F2F2" height="14" rx="4" width="585" x="0" y="64" />
        <rect fill="#FAFAFA" height="150" rx="8" width="600" x="0" y="134" />
      </ContentLoader>
    </Stack>
  );
};

export default Loader;
